import { FormGroup, Input, Label } from "reactstrap";
import DefaultModal from "../../../components/Modals/Default";
import DefaultButton from "../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";

function OfficesSearchModal({ isOpen, toggle, keyword, onKeywordChange, onSearch }) {
  const { t } = useTranslation();

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      title={t('offices.search.title')}
      size="md"
    >
      <FormGroup>
        <Label>{t('offices.search.fields.office_name.label')}</Label>
        <Input 
          type="text" 
          placeholder={t('offices.search.fields.office_name.placeholder')} 
          onChange={onKeywordChange}
          value={keyword}
        />
      </FormGroup>

      <DefaultButton color="primary" onClick={onSearch} block>
        {t('offices.search.button')}
      </DefaultButton>
    </DefaultModal>
  );
}

export default OfficesSearchModal;